<template>
  <base-container ref="container" :isLoading="loading">
    <el-row>
      <el-col
        style="padding: 5px"
        :span="8"
        v-for="(item, index) in rules"
        :key="item.id"
      >
        <el-row
          class="back-warning color-white"
          style="border-radius: 10px; padding: 5px"
          type="flex"
          justify="space-around"
          align="middle"
        >
          <div class="align-center">
            {{ item.projectName }}({{ item.projectId }})
          </div>
          <div class="align-center margin-h5 margin-v10">
            互斥<b class="margin-h3">{{ item.duration }}</b
            >天
            <div>
              <img
                style="height: 10px; width: 60px"
                src="/img/rule/repel.png"
              />
            </div>
          </div>
          <div class="align-center">
            {{ item.relateProjectName }}({{ item.relateProjectId }})
          </div>
          <el-button
            circle
            size="mini"
            type="danger"
            icon="el-icon-delete"
            plain
            @click="remove(item, index)"
          >
          </el-button>
        </el-row>
      </el-col>
      <el-col style="padding: 5px" :span="8">
        <el-button
          type="warning"
          plain
          icon="el-icon-plus"
          style="
            height: 72px;
            text-align: center;
            width: 100%;
            border-radius: 10px;
          "
          @click="addRule"
        >
          新增互斥规则
        </el-button>
      </el-col>
    </el-row>
    <artisan-dialog
      height="150px"
      width="700px"
      :visible.sync="show"
      title="新增互斥规则"
      :isLoading="dialogLoading"
    >
      <el-row type="flex" justify="space-around" align="middle">
        <div>
          <div class="align-center">项目</div>
          <el-select filterable clearable v-model="rule.projectId" size="mini">
            <el-option
              v-for="item in projects"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="margin-h5">
          互斥
          <el-input-number
            size="mini"
            style="width: 50px"
            :min="1"
            :controls="false"
            v-model="rule.duration"
          >
          </el-input-number>
          天
          <div>
            <img
              style="height: 10px; width: 100px"
              src="/img/rule/interval.png"
            />
          </div>
        </div>
        <div>
          <div class="align-center">项目</div>
          <el-select
            filterable
            clearable
            v-model="rule.relateProjectId"
            size="mini"
          >
            <el-option
              v-for="item in projects"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-row>
      <template #footer>
        <el-button
          class="margin-h5"
          size="mini"
          type="primary"
          icon="el-icon-plus"
          @click="confirmRule"
        >
          确认保存
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import prop from "./prop.js";
import { add, remove } from "@/api/jc/clinical-rule";
export default {
  mixins: [prop],
  data() {
    return {
      rule: {
        code: "interval",
        projectId: "",
        projectName: "",
        relateProjectId: "",
        relateProjectName: "",
        duration: "1",
      },
      show: false,
      loading: false,
      dialogLoading: false,
    };
  },
  methods: {
    addRule() {
      this.rule = {
        code: "interval",
        projectId: "",
        projectName: "",
        relateProjectId: "",
        relateProjectName: "",
        duration: "1",
      };
      this.show = true;
    },
    confirmRule() {
      if (
        this.rule.projectId &&
        this.rule.relateProjectId &&
        this.rule.duration
      ) {
        let rule = this.rules.find(
          (c) =>
            (c.projectId == this.rule.projectId &&
              c.relateProjectId == this.rule.relateProjectId) ||
            (c.projectId == this.rule.relateProjectId &&
              c.relateProjectId == this.rule.projectId)
        );
        if (rule) {
          this.$message({
            type: "warning",
            message: "已存在两个项目的互斥规则!",
          });
          return;
        }
        this.rule.id = "";
        let project = this.projects.find((c) => c.id == this.rule.projectId);
        this.rule.projectName = project.name;
        project = this.projects.find((c) => c.id == this.rule.relateProjectId);
        this.rule.relateProjectName = project.name;
        this.dialogLoading = true;
        add(this.rule)
          .then(() => {
            this.dialogLoading = false;
            this.show = false;
            this.loadRules();
          })
          .catch(() => {
            this.dialogLoading = false;
          });
      } else {
        this.$message({ type: "warning", message: "请输入必要的参数！" });
        return;
      }
    },
    remove(rule, index) {
      this.$refs.container.confirm({ msg: "确认删除？" }).then((res) => {
        this.loading = true;
        remove(rule.id)
          .then(() => {
            this.loading = false;
            this.loadRules();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style></style>
